const DestinatarioViaAsoEnum = {
        PRESTADOR: 'PRESTADOR',
        FUNCIONARIO: 'FUNCIONARIO',
        CLIENTE: 'CLIENTE'
    }

export default DestinatarioViaAsoEnum;
